import { IApplicationState } from '../../types/redux';
import { TUserState } from '../../types/user';

export function selectUser(state: IApplicationState): TUserState {
  return state.user;
}
